/* eslint-disable react/no-danger */
import React from 'react';
import LazyLoad from 'react-lazy-load';
import AdBlockDetect from 'react-ad-block-detect';
import _ from 'lodash';

const createSafeHtml = (encodedHtml) => ({
  __html: _.unescape(encodedHtml)
});

const AdPreview = (props) => {
  const {
    title,
    children,
    maxWidthDiv,
    maxHeight,
    offsetVertical,
    iframe_url: iframeUrl
  } = props;

  const iframeSpanContent = createSafeHtml(iframeUrl);

  return (
    <div>
      <h4>{title}</h4>
      {children || null}
      <AdBlockDetect>
        <div className="Ad-Blocker-Message">
          Please disable your ad blocker, and refresh this tab
        </div>
      </AdBlockDetect>
      <div className="filler" />
      <div style={{ maxWidth: maxWidthDiv }}>
        <LazyLoad height={maxHeight} offsetVertical={offsetVertical}>
          <span dangerouslySetInnerHTML={iframeSpanContent} />
        </LazyLoad>
      </div>
    </div>
  );
};
export default AdPreview;



// WEBPACK FOOTER //
// ./src/components/common/AdPreview.js